import type { ProfileInterface, SpotInterface } from 'types';

export const canViewLocalIntelligence = (spot: SpotInterface | null, profile?: ProfileInterface): boolean => {
    if (profile?.superuser) {
        return true;
    }

    return spot?.spot_config?.show_local_intelligence_page ?? false;
};
